/**
 * Permissive passthrough search schema for the RR7 → TanStack Router swap (HS-837).
 *
 * The router swap is one atomic step, so every list route lands with a schema that
 * preserves existing `?page=&search=&sort=` query params verbatim instead of TSR's
 * default of stripping unknown search. Each route is tightened to its data-screen
 * definition schema later, entity by entity (plan 04 §4 / 05 §3).
 */
export function passthroughSearch(search: Record<string, unknown>): Record<string, unknown> {
  return search;
}

/** Where sign-in lands when the request carried no usable `?redirect=`. */
const DEFAULT_DESTINATION = '/dashboard';

/**
 * Narrow an untrusted `?redirect=` value to a same-origin path (HS-859).
 *
 * The root auth guard stamps `search: { redirect: location.href }` onto every protected route,
 * so this value reaches the login screen from whatever the browser had in the address bar. It
 * must never be followed blind: `//evil.com` is a protocol-relative URL that a browser resolves
 * to another ORIGIN, which would turn our own login redirect into an open redirect. Requiring a
 * leading `/` and rejecting a second one keeps the destination inside this app.
 */
export function safeDestination(value: string | undefined): string {
  if (!value?.startsWith('/') || value.startsWith('//')) return DEFAULT_DESTINATION;
  return value;
}
